import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { TemplateRefDiamondsService } from './template-ref-diamonds.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-diamonds-popup',
  templateUrl: './diamonds-popup.component.html',
  styleUrl: './diamonds-popup.component.scss',
})
export class DiamondsPopupComponent implements OnInit {
  @ViewChild('diamondsPopup', { static: true }) diamondsPopup: TemplateRef<any>;
  showList: boolean = false;
  subscriptions: boolean = false;
  public user: any;
  /**
   * Constructor
   */
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private templateRefDiamondsService: TemplateRefDiamondsService,
    private modalService: NgbModal,
     @Inject("WINDOW") private window: any,
  ) {}
  ngOnInit(): void {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.user = user;
      }
    });
  }
  
  ngAfterViewInit() {
    this.templateRefDiamondsService.setDiamondsPopup(this.diamondsPopup);
  }

  subscribeto(token, subc = 0, notification_code = 'DEFAULT') {
    let stripe_price_id = '';
    let tokens = 'diamond';
    let sub_type = '0';
    if (token == 1) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgRBHqb9USI';
      //  stripe_price_id = 'price_1PXB9j03HSHmHwgRqY423W2q'; // test // 10
    } else if (token == 2) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgR4pUGQMcJ';
      // stripe_price_id = 'price_1PXBA703HSHmHwgRrGsz1caP'; // test // 50
    } else if (token == 3) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgRSrdF2phA';
      // stripe_price_id = 'price_1PXBAF03HSHmHwgRreL0wkSJ'; // test // 100
    } else if (token == 4) {
      sub_type = '2';
      tokens = 'diamonds';
      stripe_price_id = 'price_1PuwKW03HSHmHwgR4jPGT6ej'; // 29.9
      // stripe_price_id = 'price_1Pp7id03HSHmHwgRH52LRKDp'; // test // 9.9
    } else if (token == 5) {
      sub_type = '2';
      tokens = 'diamonds';
      stripe_price_id = 'price_1Pp7e703HSHmHwgRKIcJ510D';
      //  stripe_price_id = 'price_1Pp7il03HSHmHwgRIlcMGwcI'; // test // 9.9
    } else if (token == 6) {
      sub_type = '2';
      tokens = 'diamonds';
      stripe_price_id = 'price_1PuweG03HSHmHwgRqFynyOqj'; // 39.9
      //  stripe_price_id = 'price_1Pp7iu03HSHmHwgRqjNLKW0T'; // test // 29.9
    }

    let formData = new FormData();
    formData.append('id', this.user?.id);
    formData.append('stripe_price_id', stripe_price_id);
    formData.append('tokens', tokens);
    formData.append('token', token);
    formData.append('sub', subc.toString());
    formData.append('notification_code', notification_code);
    formData.append('sub_type', sub_type);

    this.auth.create_stripe_checkout_url(formData).subscribe(
      (response: any) => {
        if (response.body.url != 'r') this.window.location.href = response.body.url;
        else if (response.body.message != '') {
          if (response.body.code == 0) {
            this.subscribeto(token, 1, response.body.notification_code);
            return;
          }
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
  managesub() {
    let stripe_price_id = 'xxx';
    let tokens = 'diamond';
    let sub_type = '0';

    let formData = new FormData();
    formData.append('id', this.user?.id);
    formData.append('stripe_price_id', stripe_price_id);
    formData.append('tokens', 'xxxx');
    formData.append('notification_code', 'xxx');
    formData.append('sub_type', '3');

    this.auth.create_stripe_checkout_url(formData).subscribe(
      (response: any) => {
        if (response.body.url != 'r') this.window.location.href = response.body.url;
        else if (response.body.message != '') {
          if (response.body.code == 0) {
            this.subscribeto(response.body.notification_code);
            return;
          }
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
}
